export default __webpack_public_path__ + "static/media/image 3.b1563a1d.png";